import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import { EColorVariablesV2 } from '@/types/theme-packs.types';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';
import getThemeColorsCssMixVariable from '@/utils/colors/get-theme-color-css-mix-variable';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import SlideDownCard from '@ui/cards/slide-down-card/slide-down-card';

interface AllProfilesBulkActionsProps {
  selectedCount: number;
  onClearSelection: () => void;
  onAddToList: () => void;
  onRemoveFromList?: () => void;
}

const AllProfilesBulkActions = ({
  selectedCount,
  onClearSelection,
  onAddToList,
  onRemoveFromList,
}: AllProfilesBulkActionsProps) => {
  return (
    <SlideDownCard height="60px" open={!!selectedCount}>
      <Container
        className="flex padding-v-10 padding-h-24 radius-8 radius-b-l-0 radius-b-r-0 jc-space-between"
        background="var(--global-opacity-white-5)"
        height="60px"
      >
        <Container className="S1 flex ai-center">
          {selectedCount > 0 ? `${selectedCount} profile${selectedCount === 1 ? '' : 's'} selected` : null}
        </Container>
        <Container className="flex fa-row gap-8 no-style">
          <Button onClick={onClearSelection}>
            <Text className="L2 flex ai-center gap-6">
              <Icon name={ICONS.CLOSE} height={11} width={11} />
              <span>Clear selection</span>
            </Text>
          </Button>
          {onRemoveFromList && (
            <Button
              className="padding-8 flex ai-center jc-center gap-6"
              borderRadius="100px"
              onClick={onRemoveFromList}
              backgroundColor="var(--gray-600)"
              designSize="small"
              disabled={selectedCount === 0}
            >
              <Icon name={ICONS.TRASH} size={12} />
              <Text className="L2">Remove from list</Text>
            </Button>
          )}
          <Button
            minWidth="max-content"
            className="padding-8 flex ai-center jc-center gap-6"
            borderRadius="100px"
            onClick={onAddToList}
            backgroundColor={getThemeColorCSSVariable()}
            hoverBackgroundColor={getThemeColorsCssMixVariable()}
            designSize="small"
            disabled={selectedCount === 0}
          >
            <Icon
              color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}
              name={ICONS.ADD}
              size={12}
            />
            <Text color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}>
              Add to list
            </Text>
          </Button>
        </Container>
      </Container>
    </SlideDownCard>
  );
};
export default AllProfilesBulkActions;
